import React from "react"
import { Divider, Grid } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { isReportMultipleModalLoading, reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { MULTIPLE_MODAL_LOADING, MULTIPLE_OPTIONS, RENTAL_DATES_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import { useComputed } from "@preact/signals-react"

const buttonsContainerStyles = {
	sx: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	}
}

export default function ReportMultipleModalButtons() {

	const validation = useComputed(() => {
		return reportListMultipleData.value.key === MULTIPLE_OPTIONS.DATES
			? reportListMultipleData.value.reportsInfo.every(({ rentalDateOption }) => rentalDateOption === RENTAL_DATES_OPTIONS.SPECIFIC_DAYS) && !!reportListMultipleData.value.values.length
			: !!reportListMultipleData.value.values.length
	})
	const frequencyValidation = useComputed(() => {
		return reportListMultipleData.value?.manuallyExecution || !!(reportListMultipleData.value?.idFrequencyWhen?.length && reportListMultipleData.value?.frequencyHours?.length)
	})
	const executionDatesValidation = useComputed(() => {
		const min = reportListMultipleData.value?.executionDateMin
		const max = reportListMultipleData.value?.executionDateMax
		return (!!min && !!max) || (!min && !max)
	})
	const optionSelected = useComputed(() => reportListMultipleData.value.key)

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Divider sx={{ b: 1.5 }}/>
		</Grid>
		{optionSelected.value !== MULTIPLE_OPTIONS.FREQUENCY && optionSelected.value !== MULTIPLE_OPTIONS.EXECUTION_DATES && <Grid item xs={6}  {...buttonsContainerStyles} >
			<ButtonLoadingSeeker
				disabled={!validation.value}
				loading={!!isReportMultipleModalLoading.value}
				onClick={() => {
					isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.REMOVE
				}}
				startIcon={<IconSeeker icon="trash-can"/>}
				sx={{
					backgroundColor: "colors.red",
					color: "colors.white",
					width: 1 / 3,
				}}>
				Remove
			</ButtonLoadingSeeker>
		</Grid>}
		{optionSelected.value !== MULTIPLE_OPTIONS.FREQUENCY && optionSelected.value !== MULTIPLE_OPTIONS.EXECUTION_DATES && <Grid item xs={6} {...buttonsContainerStyles}>
			<ButtonLoadingSeeker
				disabled={!validation.value}
				loading={!!isReportMultipleModalLoading.value}
				onClick={() => {
					isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.ADD
				}}
				startIcon={<IconSeeker icon="plus"/>}
				sx={{
					backgroundColor: "colors.green",
					color: "colors.white",
					width: 1 / 3,
				}}>
				Add
			</ButtonLoadingSeeker>
		</Grid>}
		{optionSelected.value === MULTIPLE_OPTIONS.EXECUTION_DATES && <Grid item xs={12} {...buttonsContainerStyles}>
			<ButtonLoadingSeeker
				disabled={!executionDatesValidation.value}
				loading={!!isReportMultipleModalLoading.value}
				onClick={() => {
					isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.UPDATE_EXECUTION_DATES
				}}
				startIcon={<IconSeeker icon="pen"/>}
				sx={{
					color: "colors.white",
					width: 1 / 3,
				}}>
				Update
			</ButtonLoadingSeeker>
		</Grid>}
		{optionSelected.value === MULTIPLE_OPTIONS.FREQUENCY && <Grid item xs={6}>
			<ButtonLoadingSeeker
				disabled={!frequencyValidation.value}
				loading={!!isReportMultipleModalLoading.value}
				onClick={() => {
					isReportMultipleModalLoading.value = MULTIPLE_MODAL_LOADING.UPDATE
				}}
				startIcon={<IconSeeker icon="pen"/>}
				sx={{
					color: "colors.white",
					width: 1 / 3,
				}}>
				Add
			</ButtonLoadingSeeker>
		</Grid>}
	</Grid>
}